import { Block } from '../../components/layout/Block';
import { Props } from './props';
import { CheckPermissionFunction, PermissionGate } from '../../../../Auth/components/PermissionGate';
import * as React from 'react';
import { ReactElement } from 'react';
import { WorkPersonDTO, WorkPersonOtherDTO } from '../../../../api/core';
import { getDefaultLinkedPerson, getDefaultLinkedPersonOther } from '../../../../Settings/emptyModels';
import { External, Internal, LinkedPerson } from '../../components/LinkedPerson';
import { getVocabularyOptions } from '../../../../Vocabulary/util';
import { IntlShape, useIntl } from 'react-intl';



export const PersonsPage = (props: Props): ReactElement => {
  const intl: IntlShape = useIntl();
  return (
    <Block title={`work.header.persons`}>
      <PermissionGate always entity={'work_generic'} field={'work_persons'}>
        {(checkPermission: CheckPermissionFunction): ReactElement => (
          <PermissionGate always entity={'work_generic'} field="work_person_others">
            {(checkPermissionOther: CheckPermissionFunction): ReactElement => (
              <LinkedPerson
                internal={props.modifiedModel.workPersons}
                external={props.modifiedModel.workPersonOthers}
                enabledExternalIds={true}
                updateInternal={(update: Internal[]): void => props.setField('workPersons', update)}
                updateExternal={(update: External[]): void => props.setField('workPersonOthers', update)}
                newInternal={(): WorkPersonDTO => getDefaultLinkedPerson()}
                newExternal={(): WorkPersonOtherDTO => getDefaultLinkedPersonOther(true)}
                validationInternal={props.validation?.root?.fields?.work_persons}
                validationExternal={props.validation?.root?.fields?.work_person_others}
                checkPermissionInternal={checkPermission}
                checkPermissionExternal={checkPermissionOther}
                autoFocus={props.autoFocus}
                roleOptions={getVocabularyOptions(intl.locale, 'person_role_list')}
              />
            )}
          </PermissionGate>
        )}
      </PermissionGate>
    </Block>
  );
};
